import React, { Component } from 'react'
import PropTypes from 'prop-types'

import axios from 'axios'

import { Container, Row, Col, Image, Form, Button, Modal } from 'react-bootstrap'

import { IMaskInput } from "react-imask"

import styles from './../style/LoginForm.module.scss'
import icon_styles from './../style/InputIcons.module.scss'

export default class LoginForm extends Component {

  constructor(props) {
    super(props)

    this.state = {
      remember: true,
      form: 'login',
      name: '',
      email: '',
      phone: '',
      pass: '',
      cpass: '',
      show: false,
      modal_title: '',
      modal_body: '',
      legal: props.user_profile_type == 'legal',
      inn: '',
      company: ''
    }
  }

  rememberChange = () => {
    this.setState({
      remember: !this.state.remember
    })
  }

  formChange = ( form ) => {
    this.setState({
      form: form
    })
  }

  change_name = ( val ) => {
    this.setState({
      name: val
    })
  }
  change_email = ( val ) => {
    this.setState({
      email: val
    })
  }
  change_phone = ( val ) => {
    this.setState({
      phone: val
    })
  }
  change_pass = ( val ) => {
    this.setState({
      pass: val
    })
  }
  change_cpass = ( val ) => {
    this.setState({
      cpass: val
    })
  }

  change_legal = ( val ) => {
    this.setState({
      legal: val
    })
  }

  change_inn( value ) {
    this.setState({
      inn: value
    })
  }
  change_company( value ) {
    this.setState({
      company: value
    })
  }

  submitForm = ( e ) => {
    const { form, name, email, phone, pass, cpass, legal, inn, company } = this.state
    e.preventDefault()

    if(form == 'register' && pass != cpass) return

    const main = this,
    baseURL = window.location.protocol + "//" + window.location.hostname
    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'login_page',
      'form': form,
      'name': name,
      'email': email,
      'phone': phone,
      'pass': pass,
      'legal': legal ? 'on' : '',
      'inn': inn,
      'company': company
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      if( form == 'login' ) {
        if( response.data.success ) {
          location.reload()
        } else {
          main.setState({
            show: true,
            modal_title: `Ошибка`,
            modal_body: response.data.massage
          })
        }
      }
      if( form == 'remember' ) {
        if( response.data.success ) {
          main.setState({
            show: true,
            modal_title: `Забыли пароль?`,
            modal_body: `Доступы отправлены на ваш E-mail`
          })
        } else {
          main.setState({
            show: true,
            modal_title: `Ошибка`,
            modal_body: `Пользователь не найден`
          })
        }
      }
      if( form == 'register' ) {
        if( response.data.success ) {
          location.reload()
        } else {
          main.setState({
            show: true,
            modal_title: `Ошибка`,
            modal_body: response.data.massage
          })
        }
      }
    })
  }

  handleClose = () => {
    this.setState({
      show: false
    })
  }

  lodatPage = () => {
    window.load_page_data()
  }

  render() {

    const { ajax_data } = this.props,
    { remember, form, name, email, phone, pass, cpass, inn, company, show, modal_title, modal_body, legal } = this.state,
    { handleClose } = this

    return (
      <>
        <div className={styles.login_form}>
          <Container>
            <Row>
              <Col className={styles.login_form_lcolumn} lg={6}>
                {form == 'login' &&
                  <div className={styles.login_form_fcontener}>
                    <div className={styles.login_form_title}>Вход в учетную запись</div>
                    <div className={styles.login_form_podpis}>Авторизируйтесь, чтобы попасть в личный кабинет</div>
                    <Form onSubmit={( e ) => this.submitForm( e )}>

                      <Form.Control
                        className={`${styles.login_form_input} ${icon_styles.email_input}`} 
                        type="text" value={email}
                        onChange={( e ) => this.change_email( e.target.value )}
                        placeholder="Введите почту"
                      />

                      <Form.Control
                        className={`${styles.login_form_input} ${icon_styles.password_input}`} 
                        type="password"
                        value={pass}
                        onChange={( e ) => this.change_pass( e.target.value )}
                        placeholder="Введите пароль"
                      />
                      
                      <div className='w-100 d-flex align-items-center justify-content-between'>
                        <div onClick={() => this.rememberChange()} style={{ cursor: `pointer` }} className='d-flex align-items-center'>
                          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="#1E9FF6" strokeWidth="0.75"/>
                            {remember &&
                              <rect x="5" y="5" width="7" height="7" rx="3.5" fill="#1E9FF6"/>
                            }
                          </svg>
                          <div className={styles.login_form_remember}>Запомнить меня</div>
                        </div>
                        <div onClick={() => this.formChange('remember')} className={styles.login_form_zpass}>Забыли пароль?</div>
                      </div>
                      <Button type="submit" className={styles.login_form_btn + ` text-white`} variant="primary">Войти</Button>
                    </Form>
                    <div onClick={() => this.formChange('register')} className={styles.login_form_zareg_lnk}>Нет учетной записи? <span>Зарегистрируйтесь</span></div>
                  </div>
                }
                {form == 'remember' &&
                  <div className={styles.login_form_fcontener}>
                    <div className={styles.login_form_title}>Забыли пароль?</div>
                    <div className={styles.login_form_podpis}>Укажите ваш E-mail и мы отправим на него инструкцию для восстановления доступа</div>
                    <Form onSubmit={( e ) => this.submitForm( e )}>
                      
                      <Form.Control
                        className={`${styles.login_form_input} ${icon_styles.email_input}`} 
                        type="email"
                        value={email}
                        onChange={( e ) => this.change_email( e.target.value )}
                        placeholder="Введите почту"
                      />
                      
                      <div className='w-100 d-flex align-items-center justify-content-between'>
                        <div> </div>
                        <div onClick={() => this.formChange('login')} className={styles.login_form_zpass}>Войти</div>
                      </div>
                      <Button type="submit" className={styles.login_form_btn + ` text-white`} variant="primary">Отправить</Button>
                    </Form>
                    <div onClick={() => this.formChange('register')} className={styles.login_form_zareg_lnk}>Нет учетной записи? <span>Зарегистрируйтесь</span></div>
                  </div>
                }
                {form == 'register' &&
                  <div className={styles.login_form_fcontener}>
                    <div className={styles.login_form_title}>Регистрация учетной записи</div>
                    <div className={styles.login_form_podpis}>Зарегистрируйтесь, чтобы попасть в личный кабинет</div>
                    <Form onSubmit={( e ) => this.submitForm( e )}>

                      <Form.Control 
                        required 
                        name="name" 
                        className={`${styles.login_form_input} ${icon_styles.name_input}`} 
                        type="text" 
                        value={name} 
                        onChange={( e ) => this.change_name( e.target.value )} 
                        placeholder="Ваше имя" 
                      />

                      <Form.Control
                        required
                        className={`${styles.login_form_input} ${icon_styles.email_input}`} 
                        type="email"
                        value={email}
                        onChange={( e ) => this.change_email( e.target.value )}
                        placeholder="Введите почту"
                      />
                      
                      <Form.Control
                        required
                        as={IMaskInput}
                        mask="+{7} (000) 000-00-00"
                        lazy={true}
                        type="phone"
                        className={`${styles.login_form_input} ${icon_styles.phone_input}`} 
                        value={phone}
                        onChange={( e ) => this.change_phone( e.target.value )}
                        placeholder="Введите ваш номер телефона"
                      />

                      {legal &&
                        <>
                          <Form.Control 
                            required
                            name="inn" 
                            className={`${styles.login_form_input} ${icon_styles.inn_input}`} 
                            type="text" 
                            value={inn} 
                            onChange={( e ) => this.change_inn( e.target.value )} 
                            placeholder="ИНН" 
                          />

                          <Form.Control 
                            required
                            name="company" 
                            className={`${styles.login_form_input} ${icon_styles.company_input}`} 
                            type="text" 
                            value={company} 
                            onChange={( e ) => this.change_company( e.target.value )} 
                            placeholder="Название компании" 
                          />
                        </>
                      }
                      
                      <Form.Control
                        required
                        className={`${styles.login_form_input} ${icon_styles.password_input}`} 
                        type="password"
                        value={pass}
                        onChange={( e ) => this.change_pass( e.target.value )}
                        placeholder="Введите пароль"
                      />

                      <Form.Control
                        required
                        className={`${styles.login_form_input} ${icon_styles.cpassword_input}`} 
                        type="password"
                        value={cpass}
                        onChange={( e ) => this.change_cpass( e.target.value )}
                        placeholder="Подтвердите пароль"
                      />

                      {/*
                      <div className={styles.login_form_type_title}>Я хочу зарегистрироваться, как:</div>
                      <div className={styles.login_form_type_block}>
                        <Button onClick={() => this.change_legal(false)} variant="light" className={legal ? styles.login_form_type_btn_active : styles.login_form_type_btn}>Физическое лицо</Button>
                        <Button onClick={() => this.change_legal(true)} variant="light" className={!legal ? styles.login_form_type_btn_active : styles.login_form_type_btn}>Юридическое лицо</Button>
                      </div>
                      */}

                      <Button type="submit" className={styles.login_form_btn + ` text-white`} variant="primary">Зарегистрироватся</Button>
                      <div className={styles.lk_page_block_right_pconf}>
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="0.5" y="0.5" width="16" height="16" rx="8" fill="white" stroke="#1E9FF6"/>
                          <rect x="4" y="4" width="9" height="9" rx="4.5" fill="#1E9FF6"/>
                        </svg>
                        <div>Нажимая на кнопку “Отправить”, вы соглашаетесь с <a target="_blank" href="/privacy">политикой конфиденциальности</a></div>
                      </div>
                    </Form>
                    <div onClick={() => this.formChange('login')} className={styles.login_form_zareg_lnk}>Есть учетная запись? <span>Авторизируйтесь</span></div>
                  </div>
                }
              </Col>
              <Col className='d-flex align-items-center justify-content-start' lg={6}>
                {ajax_data.image &&
                  <Image className={styles.login_form_img} src={ajax_data.image} width="379" height="452" alt="Вход в учетную запись" />
                }
              </Col>
            </Row>
          </Container>
        </div>
        <Modal centered show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{modal_title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='text-center'>{modal_body}</div>
          </Modal.Body>
        </Modal>
      </>
    )
  }
}

LoginForm.propTypes = {
  ajax_data: PropTypes.object,
  user_profile_type: PropTypes.string
}